import {shopModule} from '../module.js';
import '@nuskin/ns-util';

shopModule.directive('nsLuhnCheck', ['nsUtil', function(nsUtil) {
    return {
        require: 'ngModel',
        link: function(scope, ele, attr, ctrl) {

            console.log("In nsLuhnCheck...");
            ele.on('blur', function () {
                scope.$apply(function () {
                    let type = null;

                    if (scope.sections.payment.adding) {
                        type = scope.sections.payment.newPayment.getPaymentTypeId();
                    }

                    // if not adding, it should be editing.
                    // However, we have some logic to do editing, so I keep it the way it is
                    if (scope.sections.payment.editing) {
                        type = scope.sections.payment.editPayment.getPaymentTypeId();
                    }

                    let cardValue = ele.val();
                    // This is for formatted credit card handling with luhn check
                    let removeDash = cardValue.replace(/-/g, "");
                    let isValid = nsUtil.luhnCheck(removeDash, type);
                    console.log("Calling onbur for nsLuhnCheck=" + isValid);
                    ctrl.$setValidity('nsLuhnCheck', isValid);
                });
            });
        }
    };
}]);
